module.exports = __webpack_public_path__ + "static/media/11.d4afb78d.png";